export default __webpack_public_path__ + "static/media/EquipmentRental.c5d49e01.svg";